(function () {
    "use strict";

    // Global variables
    var squiz = {
        fn: {},
        vars: {},
    };

    // Functions
    const proto = squiz.fn;

    proto.parentsUntil = function (root, node) {
        while (root) {
            if (root.classList.contains(node)) {
                return root;
            }

            root = root.parentNode;
        }

        return;
    };

    // Make squiz variable available to the console for debugging
    window.squiz = squiz;
})();

// menu collapse
const body = document.body;
const menuExpandBtn = document.querySelector(".mobile-menu");
const navMenu = document.querySelector("#header-nav");
const mediaQuery = "(min-width: 1300px)";
const mediaQueryList = window.matchMedia(mediaQuery);
const mobileCloseOverlay = document.querySelector(".nav-close-overlay");

const allToggleElements = document.querySelectorAll(
    ".header-nav__item, .header-nav__item-header, .header-nav__content, .header-nav__list"
);

function openMenu() {
    navMenu.classList.add("active");
    menuExpandBtn.setAttribute("aria-expanded", "true");
    body.classList.add("nav-active");
    mobileCloseOverlay.classList.add("active");
}

function closeMenu() {
    navMenu.classList.remove("active");
    mobileCloseOverlay.classList.remove("active");
    menuExpandBtn.setAttribute("aria-expanded", "false");
    body.classList.remove("nav-active");
    allToggleElements.forEach((el) => el.classList.remove("active"));
}

if (menuExpandBtn && navMenu) {
    menuExpandBtn.addEventListener("click", function () {
        if (navMenu.classList.contains("active")) {
            closeMenu();
        } else {
            openMenu();
        }
    });
    mediaQueryList.addEventListener("change", closeMenu);
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeMenu();
        }
    });
}

mobileCloseOverlay.addEventListener("click", () => {
    if (body.classList.contains("nav-active")) {
        closeMenu();
    }
});

// tables
function dataTable() {
    let tables = document.querySelectorAll(".data-table");
    tables.forEach((table) => {
        let newDiv = document.createElement("div");
        let nextElement = table.nextElementSibling;
        let prevElement = table.previousElementSibling;
        newDiv.classList.add("x-overflow");
        newDiv.appendChild(table);
        nextElement
            ? nextElement.parentNode.insertBefore(newDiv, nextElement)
            : prevElement.parentNode.insertBefore(
                  newDiv,
                  prevElement.nextSibling
              );
    });
}

dataTable();
